import React from "react";

export default function Footer() {
  return (
    <>
      <div className="footer">
        <div className="footer-container">
          {/* ABOUT */}
          <div className="footer-about">
            <h3>About Us</h3>

            <p>
              India’s trusted marketplace for embroidery machines, workspaces,
              and skilled designers. Buy, rent, or hire — all in one place.
            </p>
          </div>

          {/* LINKS */}
          <div className="footer-links">
            <h3>Marketplace</h3>
            <a href="/designes">Free Designs</a>
            <a href="/machine">Buy Machines</a>
            <a href="/house">Rent Workspace</a>
            <a href="/designer">Hire Designers</a>
          </div>

          {/* CATEGORY */}
          {/* <div className="footer-links">
          <h3>Support</h3>
          <a href="#">Help Center</a>
          <a href="#">Terms & Conditions</a>
          <a href="#">Privacy Policy</a>
        </div> */}

          <div className="footer-links">
            <h3>Company</h3>
            <a href="/home">Home</a>
            <a href="/contact">Contact us</a>
            <a href="/about">About us</a>
          </div>

          {/* CONTACT */}
          <div className="footer-contact">
            <h3>Contact Us</h3>
            <p>
              <i className="bi bi-geo-alt"></i> 123 Street, New York
            </p>
            <p>
              <i className="bi bi-envelope"></i> info@example.com
            </p>
            <p>
              <i className="bi bi-telephone"></i> +012 345 67890
            </p>
          </div>
        </div>

        {/* BOTTOM */}
        <div className="footer-bottom">
          <p>© 2026 Your Website | Designed by You</p>
        </div>
      </div>
    </>
  );
}
